import { useQuery } from '@tanstack/react-query'
import type { Item } from 'typings'
import { useFetch } from './useFetch'

type RnBCampaignAudienceResponse = {
  id: string
  name: string
  beginDateUtc: string
  endDateUtc?: string
  isActive?: boolean
  isAndOperator?: boolean
  isArchived: boolean
  lastModified: {
    dateUtc: string
    user: string
  }
}[]

export function useAudiences() {
  const { fetcherWrapper } = useFetch()

  const url = new URL(
    `/api/proxy/rnb/pvt/campaignConfiguration`,
    window.location.origin
  )

  async function fetcher(): Promise<Item[]> {
    return fetcherWrapper(url.toString())
      .then((r) => r.json())
      .then((r: RnBCampaignAudienceResponse): Item[] =>
        r.map((audience) => ({
          id: audience.id,
          name: audience.name,
        }))
      )
  }

  return useQuery<Item[]>({
    queryKey: ['audiences'],
    queryFn: fetcher,
  })
}
